// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"ec583e8d","232":"67a5f6a1","348":"6cca8640","391":"a46b9bab","489":"f3b6f17e","496":"ce4142eb","516":"4f5b26be","667":"381bab3a","826":"dd176afd","872":"deecbaaf"}[chunkId] + ".chunk.js";
};